import { SceneComponent } from "./types";

export const selectInitialFocus = (config: SceneComponent) => config.navigation.initialFocus;
export const selectId = <T extends { navigation: { id: string } }>(config: T) =>
	config.navigation.id;
export const selectNavigation = (config: SceneComponent) => ({ ...config.navigation });

export const fullscreenInteractiveNoIcon = {
	id: "fullscreen-interactive-no-icon",
	src: "",
	verbs: [],
	protected: false,
	position: {
		hitbox: { x: 0, y: 0, width: 100, height: 100 },
		icon: { x: 0, y: 0, width: 0, height: 0 },
	},
} as const;
